import React from "react";
import "./styles.scss";
import SkeletonLine from "../../../common/Skeletion/line";

const HeadDescription = ({ data }) => {
  return (
    <div className="head-description-container">
      {data?.order_summary_description ? (
        <>
          <h3>One step checkout</h3>
          <p
            dangerouslySetInnerHTML={{ __html: data.order_summary_description }}
          />
        </>
      ) : (
        Array.from({ length: 5 }, (_, index) => (
          <SkeletonLine key={index} style={{ height: "2vh", margin: "2px" }} />
        ))
      )}
    </div>
  );
};

export default HeadDescription;
